
import { Component, Vue, Prop } from "vue-property-decorator";
import { ServicePointBalance } from "@/entities";
import PIcon from "@/common/components/look/PIcon/PIcon.vue";
import {
  DEVICE_TYPE_AC,
  DEVICE_TYPE_ACCEPTOR,
  DEVICE_TYPE_RE,
  DEVICE_TYPE_RECYCLER,
} from "@/pages/dashboard/dashboard.type";

@Component({
  components: {
    PIcon,
  },
})
export default class ServicePointDetailHeader extends Vue {
  @Prop() public servicePointBalance!: ServicePointBalance;

  get solutionTypeTranslate(): string {
    if (
      this.servicePointBalance.deviceType.toUpperCase() === DEVICE_TYPE_AC ||
      this.servicePointBalance.deviceType.toUpperCase() === DEVICE_TYPE_ACCEPTOR
    ) {
      return this.$i18n.t("solutionType.acceptor");
    } else if (
      this.servicePointBalance.deviceType.toUpperCase() === DEVICE_TYPE_RE ||
      this.servicePointBalance.deviceType.toUpperCase() === DEVICE_TYPE_RECYCLER
    ) {
      return this.$i18n.t("solutionType.recycler");
    }
    return this.$i18n.t("solutionType.undefined");
  }
}
